export function updateText(id, text) {
  const elem = document.querySelector(id);
  elem.innerText = text;
}